
import { useTranslation } from "react-i18next";
import ChatInterface from "@/components/chat/ChatInterface";
import DesktopLayout from "@/components/layout/DesktopLayout";
import { useFlutterBridge } from "@/hooks/useFlutterBridge";

const Assistant = () => {
  const { t } = useTranslation();
  useFlutterBridge(null);
  return (
    <DesktopLayout>
      <div className="container px-4 py-6">
        <h1 className="text-2xl font-bold mb-4">{t("assistant.title", "AI Assistant")}</h1>
        <ChatInterface />
      </div>
    </DesktopLayout>
  );
};

export default Assistant;
